<template>
  <div v-if="advList[advPostionName] && advList[advPostionName].showStatus">
    <div v-if="advList[advPostionName].adType===2">
      <div v-if="advList[advPostionName].showType===1 || advList[advPostionName].list[0].adCode" class="adv">
        <iframe
          ref="adv"
          name="adv"
          class="iframecloud"
          width="100%"
          height="160"
          frameborder="0"
          :src="advList[advPostionName].list[0].adCode"
          scrolling="no"
        />
      </div>
    </div>
    <div v-if="advList[advPostionName].adType===1">
      <div v-if="advList[advPostionName].showType===1 || advList[advPostionName].list.length>0" class="adv">
        <div v-if="advList[advPostionName].list.length>1" class="div-layout-warp-adv listbox-bottom pd0">
          <el-carousel :interval="5000" arrow="always" height="160px">
            <el-carousel-item v-for="item in advList[advPostionName].list" :key="item.id">
              <a :href="item.url|urlAddToken" :title="item.title" :target="item.url?'_blank':'_self'">
                <img :src="item.path" class="image" width="100%">
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div v-else class="div-layout-warp-adv listbox-bottom pd0">
          <div v-if="advList[advPostionName].list.length>0 " class="imgbox">
            <a :href="advList[advPostionName].list[0].url|urlAddToken" :title="advList[advPostionName].list[0].title" :target="advList[advPostionName].list[0].url?'_blank':'_self'">
              <img :src="advList[advPostionName].list[0].path" class="image" width="100%">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'AdvItem',
  components: {
  },
  props: {
    advPostionName: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['advList'])
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.adv{
  border: 1px solid #fff;
  margin: 40px 0;
  height: 160px;
  img{transition: transform 0.2s;transform: scale(1)}
   &:hover img{transform: scale(1.05)}
}
.imgbox{
  height: 160px;
}
.image{
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
</style>
